/** Admin panel permission keys — must stay in sync with Node `adminPermissions.ts` */
export const AdminPermission = {
  EVENT_MANAGEMENT: 'event_management',
  USERS: 'users',
  AFFILIATES: 'affiliates',
  BONUS: 'bonus',
  MARKET_ANALYSIS: 'market_analysis',
  PAYMENT_METHOD: 'payment_method',
  PAYMENT_SETTINGS: 'payment_settings',
  RESULT_DECLARATION: 'result_declaration',
  ADMIN_PL: 'admin_pl',
  ACCOUNT_STATEMENT: 'account_statement',
  CURRENT_BETS: 'current_bets',
  DELETED_BETS: 'deleted_bets',
  GAME_REPORTS: 'game_reports',
  PROFIT_LOSS: 'profit_loss',
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  LEDGER: 'ledger',
  USER_BOOK: 'user_book',
  SECURITY_MONITORING: 'security_monitoring',
  BLOCK_MARKETS: 'block_markets',
  MESSAGES: 'messages',
  WHATSAPP: 'whatsapp',
  ADD_MATCH: 'add_match',
  CASINO_LIST: 'casino_list',
  CASINO_VISIBILITY: 'casino_visibility',
  UNDECLARED_BETS: 'undeclared_bets',
  SERIES_SETTINGS: 'series_settings',
  BET_DELAY: 'bet_delay',
  MATCH_SETTINGS: 'match_settings',
  RBAC_MANAGE: 'rbac_manage',
} as const

export type AdminPermissionKey = (typeof AdminPermission)[keyof typeof AdminPermission]

export const PERMISSION_LABELS: Record<AdminPermissionKey, string> = {
  [AdminPermission.EVENT_MANAGEMENT]: 'Event Management',
  [AdminPermission.USERS]: 'Users',
  [AdminPermission.AFFILIATES]: 'Affiliates',
  [AdminPermission.BONUS]: 'Bonus',
  [AdminPermission.MARKET_ANALYSIS]: 'Market Analysis',
  [AdminPermission.PAYMENT_METHOD]: 'Payment Details',
  [AdminPermission.PAYMENT_SETTINGS]: 'Payment Settings',
  [AdminPermission.RESULT_DECLARATION]: 'Result Declaration',
  [AdminPermission.ADMIN_PL]: 'Admin P&L',
  [AdminPermission.ACCOUNT_STATEMENT]: "Account's Statement",
  [AdminPermission.CURRENT_BETS]: 'Current Bets',
  [AdminPermission.DELETED_BETS]: 'Deleted Bets',
  [AdminPermission.GAME_REPORTS]: 'Game Reports',
  [AdminPermission.PROFIT_LOSS]: 'Profit And Loss',
  [AdminPermission.DEPOSIT]: 'Deposit',
  [AdminPermission.WITHDRAW]: 'Withdraw',
  [AdminPermission.LEDGER]: 'Ledger',
  [AdminPermission.USER_BOOK]: 'User Book',
  [AdminPermission.SECURITY_MONITORING]: 'Security Monitoring',
  [AdminPermission.BLOCK_MARKETS]: 'Block Markets',
  [AdminPermission.MESSAGES]: 'Messages',
  [AdminPermission.WHATSAPP]: 'WhatsApp Numbers',
  [AdminPermission.ADD_MATCH]: 'Add Match List',
  [AdminPermission.CASINO_LIST]: 'Casino List',
  [AdminPermission.CASINO_VISIBILITY]: 'Casino Visibility',
  [AdminPermission.UNDECLARED_BETS]: 'Undeclared Bets',
  [AdminPermission.SERIES_SETTINGS]: 'Series Settings',
  [AdminPermission.BET_DELAY]: 'Bet Delay',
  [AdminPermission.MATCH_SETTINGS]: 'Match Settings',
  [AdminPermission.RBAC_MANAGE]: 'RBAC User Management',
}
